<!-- Modal -->
<div class="modal fade" id="exampleModal3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Modificación del Detalle cod: [{{ coddet }}]</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div class="modal-body">
                <h5 style="color:gray">Detalle: "{{ DETALLE }}"</h5>
                <h5>Fecha Ticket: {{ FECHA_TICKET }}</h5>
                <h5>Importe: ${{ IMPORTE }}</h5>
                <h5>Observaciones: {{ OBSERVACIONES }}</h5>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="updateDetalle()" type="button" class="btn btn-success">APLICAR!</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">¿Desea eliminar el Detalle cod: [{{ coddet }}]</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <h5 style="color:gray">Detalle: "{{ DETALLE }}"</h5>
                <h5>"Importe: ${{ IMPORTE }}"</h5>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="eliminarDetalle()" routerLink="/verdetalles" type="button" class="btn btn-danger">-Eliminar!</button>
            </div>
        </div>
    </div>
</div>

<div id="contenedor" class="col-lg-9 animated fadeIn">
    <form>
        <div class="form-row">
            <div class="form-group col-md-3">
                <label for="inputEmail4">COD_DETALLE</label>
                <input type="email" class="form-control" name="COD_DETALLE" id="COD_DETALLE" value="{{COD_DETALLE}}" readonly="readonly">
            </div>
            <div class="form-group col-md-3">
                <label for="inputfechacarga">FECHA DE CARGA</label>
                <input type="text" class="form-control" name="FECHA_CARGA" id="FECHA_CARGA" value="{{ FECHA_CARGA }}" readonly="readonly">
            </div>
        </div>
        <div class="form-group col-md-3">
            <label for="inputfechaticket">FECHA TICKET</label>
            <input type="text" class="form-control" [(ngModel)]="FECHA_TICKET" name="FECHA_TICKET" id="FECHA_TICKET" value="{{ FECHA_TICKET }}">
        </div>
        <div class="form-group">
            <label for="inputdetalle">DETALLE</label>
            <input type="text" class="form-control" [(ngModel)]="DETALLE" name="DETALLE" id="DETALLE" value="{{ DETALLE }}">
        </div>
        <div class="form-row">
            <div class="form-group col-md-3">
                <label for="inputimporte">IMPORTE</label>
                <input type="text" class="form-control" [(ngModel)]="IMPORTE" name="IMPORTE" id="IMPORTE" value="{{ IMPORTE }}">
            </div>
            <div class="form-group col-md-3">
                <div class="form-group">
                    <label for="inputcategoria">CATEGORÍA</label>
                    <select [(ngModel)]="CATEGORIA" name="CATEGORIA" id="CATEGORIA" class="form-control">
                      <option *ngFor="let cat of dataSourceCategorias;" [value]="cat.codysub">{{ cat.detalle | uppercase}} ({{cat.codigo}}-{{cat.sub_codigo}})</option>
                    </select>
                </div>
            </div>
            <div class="form-group col-md-3">
                <label for="inputobs">OBSERVACIONES</label>
                <input type="text" class="form-control" [(ngModel)]="OBSERVACIONES" name="OBSERVACIONES" id="OBSERVACIONES" value="{{ OBSERVACIONES }}">
            </div>
        </div>

        <!-- Button trigger modal 3 -->
        <button *ngIf="coddet" type="button" class="btn btn-success" data-toggle="modal" data-target="#exampleModal3">
        GUARDAR CAMBIOS
    </button>
        <!-- Button trigger modal 2 -->
        <button *ngIf="coddet" type="button" class="btn btn-danger" data-toggle="modal" data-target="#exampleModal2">
      ¿ELIMINAR?
    </button>

    </form>
</div>
<br>
<button type="button" class="btn btn-secondary" mat-button (click)="volver()" routerLink="/verdetalles">Volver</button>